module.exports = __webpack_public_path__ + "static/img/akum_600_320.c867937.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_320.svg
// module id = GQDI
// module chunks = 1